var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 19.5,
    fill: "#000",
    stroke: "#000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "#fff",
    stroke: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.189 16.937v4.122a3.588 3.588 0 0 0-4.5 3.324 3.243 3.243 0 0 0 3.467 3.442 3.23 3.23 0 0 0 3.467-3.489V8H24.7c.693 4.315 2.851 5.316 5.74 5.778v4.135a12.293 12.293 0 0 1-5.625-1.9v8.167c0 3.7-2.19 7.82-7.627 7.82a7.665 7.665 0 0 1-7.628-7.859 7.517 7.517 0 0 1 8.629-7.204Z",
    fill: "#000"
  })));
};
export default SvgTiktok;